module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/11n-639df886958499f6f0fc32c22b8e2b3d.svg";